import MagicBento from "../components/MagicBento";
import "./TestingPageThree.css";
import "./AboutPage.css";

const aboutTemplateCards = [
  { id: "about-1", layout: "about", color: "rgba(255, 255, 255, 0.9)" },
  { id: "about-2", layout: "experience", color: "rgba(255, 255, 255, 0.9)" },
  { id: "about-3", layout: "skills", color: "rgba(255, 255, 255, 0.9)" },
  { id: "about-4", layout: "favorites", color: "rgba(255, 255, 255, 0.9)" },
  { id: "about-5", layout: "hobby", color: "rgba(255, 255, 255, 0.9)" },
];

export default function AboutPage() {
  return (
    <div className="testing3-page about-bento-page">
      <main className="testing3-main">
        <section className="testing3-bento">
          <MagicBento
            cards={aboutTemplateCards}
            glowColor="255, 140, 66"
            enableTilt={false}
          />
        </section>
      </main>
    </div>
  );
}
